// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();

    // Add loading indicator to prevent premature redirects
    if (loading) {
        return <div className="d-flex justify-content-center mt-5">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>;
    }

    // Only redirect after loading is complete
    return user ? children : <Navigate to="/" replace />;
}

export default ProtectedRoute;